import Big from 'bignumber.js';
import get from 'lodash/get';
import { formatTimeLocal, formatDateLocal } from '../../../../utils/time';
import { CalculatedMargin } from './CalculatedMarginGrid';
import parseSymbol from 'utils/parseSymbol';

const getColumnDefs = (tradeDate: string, approvalCompletedTime: string) => [
  {
    field: 'tradeDate',
    headerName: 'Effective Trade Date',
    filter: 'agMultiColumnFilter',
    valueGetter: () => formatDateLocal(tradeDate),
    initialWidth: 200,
  },
  {
    field: 'approvalCompletedTime',
    headerName: 'Approval Date',
    filter: 'agMultiColumnFilter',
    valueGetter: () => formatTimeLocal(approvalCompletedTime),
    initialWidth: 200,
  },
  {
    headerName: 'Exchange',
    filter: 'agMultiColumnFilter',
    valueGetter: ({ data }) => {
      const frontContract = get(data, 'frontContract');
      return parseSymbol(frontContract).exchangeMicCode;
    },
    initialWidth: 150,
  },
  {
    field: 'product',
    headerName: 'Product',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'marginProfile',
    headerName: 'Profile Name',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
  },
  {
    headerName: 'Contract 1',
    filter: 'agMultiColumnFilter',
    valueGetter: ({ data }) => {
      const frontContract = get(data, 'frontContract');
      return parseSymbol(frontContract).contractSymbol;
    },
    initialWidth: 150,
  },
  {
    headerName: 'Contract 2',
    filter: 'agMultiColumnFilter',
    valueGetter: ({ data }) => {
      const backContract = get(data, 'backContract');
      return parseSymbol(backContract).contractSymbol;
    },
    initialWidth: 150,
  },
  {
    headerName: 'Override Margin Rate USD',
    field: 'overrideMarginRateUsd',
    filter: 'agMultiColumnFilter',
    initialWidth: 230,
  },
  {
    headerName: 'Reference Price',
    field: 'referencePrice',
    filter: 'agMultiColumnFilter',
    initialWidth: 180,
  },
  {
    headerName: 'Contract Size',
    field: 'contractSize',
    filter: 'agMultiColumnFilter',
    initialWidth: 180,
  },
  {
    headerName: 'New Initial Margin',
    field: 'initialMargin',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
  },
  {
    headerName: 'Previous Initial Margin',
    field: 'prevInitialMargin',
    filter: 'agMultiColumnFilter',
    initialWidth: 220,
  },
  {
    headerName: 'Initial Margin Change',
    valueGetter: ({ data }: { data?: CalculatedMargin }) => {
      return data?.prevInitialMargin && data?.initialMargin
        ? new Big(data.initialMargin)
            .minus(new Big(data.prevInitialMargin))
            .toString()
        : '';
    },
    filter: 'agMultiColumnFilter',
  },
  {
    headerName: 'New Maintenance Margin',
    field: 'maintenanceMargin',
    filter: 'agMultiColumnFilter',
  },
  {
    headerName: 'Previous Maintenance Margin',
    field: 'prevMaintenanceMargin',
    filter: 'agMultiColumnFilter',
    initialWidth: 250,
  },
  {
    headerName: 'Maintenance Margin Change',
    valueGetter: ({ data }: { data?: CalculatedMargin }) =>
      data?.prevMaintenanceMargin && data?.maintenanceMargin
        ? new Big(data.maintenanceMargin)
            .minus(new Big(data.prevMaintenanceMargin))
            .toString()
        : '',
    filter: 'agMultiColumnFilter',
    initialWidth: 250,
  },
];

export default getColumnDefs;
